export default __webpack_public_path__ + "assets/logsIcon.png";